const CONVERSIONS_DEFAULT_TYPE = 'default_type'
const CONVERSIONS_DEFAULT_TYPE_ALIAS = 'Conversion'
const CONVERSIONS_TYPES_EMPTY_SHAPE = {
  default_type: CONVERSIONS_DEFAULT_TYPE_ALIAS,
  type1: "",
  type2: "",
  type3: "",
  type4: "",
  type5: "",
  type6: "",
  type7: "",
  type8: "",
  type9: "",
  type10: "",
}

export {
  CONVERSIONS_TYPES_EMPTY_SHAPE,
  CONVERSIONS_DEFAULT_TYPE,
  CONVERSIONS_DEFAULT_TYPE_ALIAS,
}
